import { Injectable } from '@angular/core';
import { CanActivate, CanLoad } from '@angular/router';
import { NavController } from '@ionic/angular';
import { Observable } from 'rxjs';
import { map, take, tap } from 'rxjs/operators';

import { SharedServiceService } from '../../services/shared-service.service';

@Injectable({
  providedIn: 'root'
})
export class RegisterGuard implements CanActivate, CanLoad {

  constructor(
    private sharedS: SharedServiceService
    , private nav: NavController
  ) { }

  canLoad(): Observable<boolean> {
    return this.sharedS.dataTendero
      .pipe(
        map(tendero => tendero.ID_Bodega > 0),
        tap(estado => {
          if (!estado) {
            this.nav.navigateRoot(['/registro/registro'], { animated: true, animationDirection: 'forward' })
          }
        }),
        take(1)
      );
  }

  canActivate(): Observable<boolean> {
    return this.sharedS.dataTendero
      .pipe(
        map(tendero => tendero.ID_Bodega > 0),
        tap(estado => {
          if (!estado) {
            this.nav.navigateRoot(['/registro/registro'], { animated: true, animationDirection: 'forward' })
          }
        }),
      );
  }

}
